/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'ai-summary-label': '要約',
  'copy-content-link-label': 'リンクをコピー',
  'dynamic-cards-search-page.advanced-search.labels.filter.no.text': 'ラベル検索に入力を開始',
  'dynamic-cards-search-page.app-filter-sidebar.all': 'すべて',
  'dynamic-cards-search-page.app-filter-sidebar.group': '検索を製品で絞り込む',
  'dynamic-cards-search-page.atlas.for': ':',
  'dynamic-cards-search-page.avatar': 'アバター',
  'dynamic-cards-search-page.calendar-event-search-result.calendar-label': 'カレンダー',
  'dynamic-cards-search-page.calendar-event-search-result.join-meeting-link': 'ミーティングに参加',
  'dynamic-cards-search-page.calendar-event-search-result.meeting-link': 'ミーティングのリンク',
  'dynamic-cards-search-page.calendar-event-search-result.meeting-link-icon': 'ミーティングに参加',
  'dynamic-cards-search-page.calendar-event-search-result.past-events-button': '過去のイベント',
  'dynamic-cards-search-page.calendar-event-search-result.recurring-event-icon': '定期イベント',
  'dynamic-cards-search-page.calendar-event-search-result.recurring-event-label': '繰り返し',
  'dynamic-cards-search-page.calendar-event-search-result.upcoming-events-button': '今後のイベント',
  'dynamic-cards-search-page.compass.owner-name': '所有者: {ownerName}',
  'dynamic-cards-search-page.compass.state': '{state}',
  'dynamic-cards-search-page.compass.tier': '第 {tier} 階層',
  'dynamic-cards-search-page.confluence.filter.content.placeholder': 'コンテンツを検索',
  'dynamic-cards-search-page.confluence.filter.content.selected': '選択済み',
  'dynamic-cards-search-page.confluence.filter.content.unselected': '候補',
  'dynamic-cards-search-page.confluence.filter.contributor.label.selected': '選択済み',
  'dynamic-cards-search-page.confluence.filter.contributor.label.unselected': '候補',
  'dynamic-cards-search-page.confluence.filter.contributor.placeholder': 'ユーザーを検索',
  'dynamic-cards-search-page.confluence.filter.label.selected': '選択済み',
  'dynamic-cards-search-page.confluence.filter.labels.placeholder': 'ラベルを検索',
  'dynamic-cards-search-page.confluence.filter.space.placeholder': 'スペースを検索',
  'dynamic-cards-search-page.connect_third_party_product_description':
    '表示されていない結果を確認するには、アカウントを接続してください',
  'dynamic-cards-search-page.connect_third_party_product_title': '管理者が {product} を追加しました!',
  'dynamic-cards-search-page.connect_third_party_product_title_alternate': '{product} が利用可能になりました!',
  'dynamic-cards-search-page.date.filter.custom.invalid.after.end': '開始日は終了日より前の日付にしてください',
  'dynamic-cards-search-page.date.filter.custom.invalid.after.today': '開始日に将来の日付を指定することはできません',
  'dynamic-cards-search-page.date.filter.custom.invalid.to.after.today': '終了日に将来の日付を指定することはできません',
  'dynamic-cards-search-page.date.filter.last.month': '過去 30 日',
  'dynamic-cards-search-page.date.filter.last.week': '過去 7 日',
  'dynamic-cards-search-page.date.filter.last.year': '過去 1 年',
  'dynamic-cards-search-page.document-search-result.google-docs-label': 'ドキュメント',
  'dynamic-cards-search-page.document-search-result.ms-excel-label': 'Excel',
  'dynamic-cards-search-page.document-search-result.ms-powerpoint-label': 'PowerPoint',
  'dynamic-cards-search-page.document-search-result.ms-word-label': 'Word',
  'dynamic-cards-search-page.dropdown_generate_answer': '回答を生成する',
  'dynamic-cards-search-page.dropdown_recent_icon_label': '最近',
  'dynamic-cards-search-page.error_primary': '検索中に問題が発生しました。',
  'dynamic-cards-search-page.error_secondary': '一時的に中断されたようです。<btn>再試行</btn>してください。',
  'dynamic-cards-search-page.externalPeopleLabel': '外部ユーザー、#{channelName}',
  'dynamic-cards-search-page.filter.clear.filter.label': 'フィルターをクリア',
  'dynamic-cards-search-page.filter.last.updated.anytime': '指定なし',
  'dynamic-cards-search-page.filter.last.updated.past30Days': '過去 30 日',
  'dynamic-cards-search-page.filter.last.updated.past7Days': '過去 7 日',
  'dynamic-cards-search-page.filter.last.updated.pastYear': '過去 1 年',
  'dynamic-cards-search-page.filter.last.updated.today': '今日',
  'dynamic-cards-search-page.filter.last.updated.yesterday': '昨日',
  'dynamic-cards-search-page.filter.type.answer': '回答',
  'dynamic-cards-search-page.filter.type.attachment': '添付ファイル',
  'dynamic-cards-search-page.filter.type.blogpost': 'ブログ投稿',
  'dynamic-cards-search-page.filter.type.branch': 'ブランチ',
  'dynamic-cards-search-page.filter.type.calendar': 'カレンダー',
  'dynamic-cards-search-page.filter.type.comment': 'コメント',
  'dynamic-cards-search-page.filter.type.commit': 'コミット',
  'dynamic-cards-search-page.filter.type.component': 'コンポーネント',
  'dynamic-cards-search-page.filter.type.conversation': '会話',
  'dynamic-cards-search-page.filter.type.database': 'データベース',
  'dynamic-cards-search-page.filter.type.design': 'デザイン',
  'dynamic-cards-search-page.filter.type.documents': 'ドキュメント',
  'dynamic-cards-search-page.filter.type.issue': '課題',
  'dynamic-cards-search-page.filter.type.message': 'メッセージ',
  'dynamic-cards-search-page.filter.type.page': 'ページ',
  'dynamic-cards-search-page.filter.type.placeholder': 'タイプを検索',
  'dynamic-cards-search-page.filter.type.presentation': 'プレゼンテーション',
  'dynamic-cards-search-page.filter.type.pull-request': 'プル リクエスト',
  'dynamic-cards-search-page.filter.type.question': '質問',
  'dynamic-cards-search-page.filter.type.repository': 'リポジトリ',
  'dynamic-cards-search-page.filter.type.space': 'スペース',
  'dynamic-cards-search-page.filter.type.space-calendar': 'スペース カレンダー',
  'dynamic-cards-search-page.filter.type.spreadsheet': 'スプレッドシート',
  'dynamic-cards-search-page.filter.type.video': '動画',
  'dynamic-cards-search-page.filter.type.web-page': 'Web ページ',
  'dynamic-cards-search-page.filter.type.whiteboard': 'ホワイトボード',
  'dynamic-cards-search-page.filters.dropdown.clear-all': 'すべてクリア',
  'dynamic-cards-search-page.filters.dropdown.title': 'フィルター',
  'dynamic-cards-search-page.filters.names.content': 'コンテンツの場所',
  'dynamic-cards-search-page.filters.names.contributor': '投稿者',
  'dynamic-cards-search-page.filters.names.labels': 'ラベル',
  'dynamic-cards-search-page.filters.names.titleMatchOnly': 'タイトルが一致',
  'dynamic-cards-search-page.github-branch-result.label': 'ブランチ',
  'dynamic-cards-search-page.github-commit-result.label': 'コミット',
  'dynamic-cards-search-page.github-pull-request-result.label': 'プル リクエスト',
  'dynamic-cards-search-page.input_placeholder': '検索するか、何でもご質問ください',
  'dynamic-cards-search-page.input_placeholder_search_only': '検索してください',
  'dynamic-cards-search-page.jira.filter.assignee.placeholder': 'ユーザーを検索',
  'dynamic-cards-search-page.jira.filter.project.placeholder': 'プロジェクトを検索',
  'dynamic-cards-search-page.landing_primary': 'まず動的カード用のフィルターを設定しましょう',
  'dynamic-cards-search-page.legacy-third-party-result.google-presentation-label': 'スライド',
  'dynamic-cards-search-page.legacy-third-party-result.google-sheets-label': 'スプレッドシート',
  'dynamic-cards-search-page.legacy-third-party-result.ms-excel-label': 'Excel',
  'dynamic-cards-search-page.legacy-third-party-result.ms-powerpoint-label': 'PowerPoint',
  'dynamic-cards-search-page.legacy-third-party-result.slack-label': 'Slack',
  'dynamic-cards-search-page.no_results_primary': '検索内容に一致する結果がありません。',
  'dynamic-cards-search-page.no_results_secondary_some_filters_applied':
    'フィルターが適用されているようです。フィルターをクリアしてみてください。',
  'dynamic-cards-search-page.nouns.tag': 'タグ',
  'dynamic-cards-search-page.nouns.tags': 'タグ',
  'dynamic-cards-search-page.number_of_results': '{totalCount,number} 件中 {numberOfResults,number} 件を表示しています',
  'dynamic-cards-search-page.oauth-banner.authorization-fail': '{product} を認証できませんでした。',
  'dynamic-cards-search-page.oauth-banner.authorization-success': '{product} が認証されました。',
  'dynamic-cards-search-page.oauth-message-connect': '接続',
  'dynamic-cards-search-page.products.custom-website': 'Web ページ',
  'dynamic-cards-search-page.results-sort.createdDate.selected': '作成順にソート (新しい順)',
  'dynamic-cards-search-page.results-sort.createdDateDESC': '作成順 (新しい順)',
  'dynamic-cards-search-page.results-sort.latestModifiedDateDESC': '更新順 (新しい順)',
  'dynamic-cards-search-page.results-sort.latestModifiedDateDESC.selected': '更新順にソート (新しい順)',
  'dynamic-cards-search-page.results-sort.sort-options.label': 'リストのソートを変更',
  'dynamic-cards-search-page.rovo-onboarding-next': '次へ',
  'dynamic-cards-search-page.rovo-onboarding-step-1-description':
    '製品で絞り込むと、より関連性の高い検索結果が表示されます。',
  'dynamic-cards-search-page.rovo-onboarding-step-1-heading': '会社のすべてのワークスペースを検索する',
  'dynamic-cards-search-page.rovo-onboarding-step-1-progress': '1/2',
  'dynamic-cards-search-page.rovo-onboarding-step-2-description':
    '絞り込んだ製品によってオプションが変わり、目的の検索結果にたどり着きやすくなります。',
  'dynamic-cards-search-page.rovo-onboarding-step-2-heading': '条件に一致するものを見つける',
  'dynamic-cards-search-page.rovo-onboarding-step-2-progress': '2/2',
  'dynamic-cards-search-page.search-result.attachment-label': '添付ファイル',
  'dynamic-cards-search-page.search-result.attachments.attached-date.label': '添付日: {formattedDate}',
  'dynamic-cards-search-page.search-result.attachments.audio-label': '音声',
  'dynamic-cards-search-page.search-result.attachments.image-label': '画像',
  'dynamic-cards-search-page.search-result.attachments.pdf-label': 'PDF',
  'dynamic-cards-search-page.search-result.last-modified': '更新日: {formattedDate}',
  'dynamic-cards-search-page.search-result.private-channel-label': '非公開チャンネル',
  'dynamic-cards-search-page.search-result.remove-recent-search': '最近の検索を削除するアイコン',
  'dynamic-cards-search-page.search-result.repository-label': 'リポジトリ',
  'dynamic-cards-search-page.search-result.thread-title-wth-others':
    '{contributorCount, plural, =0 {外部ユーザーを含むグループ メッセージ} =2 {{name1} さんと {name2} さん} =3 {{name1} さん、{name2} さん、{name3} さん} =4 {{name1} さん、{name2} さん、{name3} さん、他 {overflowContributorCount} 名} other {{name1} さん、{name2} さん、{name3} さん、他 {overflowContributorCount} 名}}',
  'dynamic-cards-search-page.search-result.unknown-channel-in-thread': '不明なチャンネル',
  'dynamic-cards-search-page.search_result_type_answer': '回答',
  'dynamic-cards-search-page.search_result_type_card': 'カード',
  'dynamic-cards-search-page.search_result_type_component': 'コンポーネント',
  'dynamic-cards-search-page.search_result_type_document': 'ドキュメント',
  'dynamic-cards-search-page.search_result_type_embed': 'スマート リンク',
  'dynamic-cards-search-page.search_result_type_folder': 'フォルダー',
  'dynamic-cards-search-page.search_result_type_presentation': 'プレゼンテーション',
  'dynamic-cards-search-page.search_result_type_pull_request': 'プル リクエスト',
  'dynamic-cards-search-page.search_result_type_sharepoint_document': 'SharePoint ドキュメント',
  'dynamic-cards-search-page.search_result_type_space_calendar': 'スペース カレンダー',
  'dynamic-cards-search-page.search_result_type_spreadsheet': 'スプレッドシート',
  'dynamic-cards-search-page.search_result_type_unrecognised': '認識できません',
  'dynamic-cards-search-page.sidebar-authorize_connect_third_party_product':
    '管理者が <strong>{product}</strong> を追加しました!{br}アカウントを接続すると、自分だけがアクセスできるドキュメントも含めて、これまで表示されなかった結果が表示されるようになります。',
  'dynamic-cards-search-page.sidebar-authorize_connect_third_party_product_alternate':
    '<strong>{product} が利用可能になりました!</strong>{br}自分だけがアクセスできるドキュメントも含めて、これまで表示されなかった結果が表示されるようになります。',
  'dynamic-cards-search-page.sidebar-oauth-warning-authorize': '認証',
  'dynamic-cards-search-page.sidebar-oauth-warning.authorization-fail': '{product} を認証できませんでした。',
  'dynamic-cards-search-page.sidebar-oauth-warning.authorization-success': '{product} が認証されました。',
  'dynamic-cards-search-page.tab-filter.all-filter-visual-label': 'すべてのアプリで絞り込む',
  'dynamic-cards-search-page.tab-filter.more-dropdown-label': '他のアプリで絞り込む',
  'dynamic-cards-search-page.townsquare.api.goal-state.archived': 'アーカイブ済み',
  'dynamic-cards-search-page.townsquare.api.goal-state.at-risk': 'リスクあり',
  'dynamic-cards-search-page.townsquare.api.goal-state.cancelled': 'キャンセル済み',
  'dynamic-cards-search-page.townsquare.api.goal-state.completed': '完了',
  'dynamic-cards-search-page.townsquare.api.goal-state.off-track': '逸脱',
  'dynamic-cards-search-page.townsquare.api.goal-state.on-track': '順調',
  'dynamic-cards-search-page.townsquare.api.goal-state.paused': '一時停止',
  'dynamic-cards-search-page.townsquare.api.goal-state.pending': '保留中',
  'dynamic-cards-search-page.video-search-result.dropdown-message':
    '{chapterCount, plural, other {この動画には {chapterCount,number} 個のチャプターがあります}}',
  'dynamic-cards-search-page.video-search-result.video-icon-label': 'ビデオ アイコン',
  'dynamic-cards-search-page.video-search-result.video-thumbnail-alt-text': 'ビデオのサムネイル',
  'dynamic-cards-search-page.work-item-assignee.assigned': ' に割り当て済み',
  'dynamic-cards-search-page.work-item-creator.created': 'が作成',
  'dynamic-cards-search-page.work-item-status.for': '→',
  'dynamic-cards-search-page.work-item-ticket.label': 'チケット',
  'dynamic-cards-search-page.work-item.label': '作業項目',
  'initialsAvatar.label': 'イニシャル アバター',
  'personAvatar.label': '人物アバター',
  'search-page.results.private-result-label': '非公開',
  'search-page.results.private-result-tooltip': '自分のみに公開されます',
  'search-page.results.product-results.third-party.channel-member-count':
    '{memberCount, plural, other {{memberCount,number} 人のメンバー}}',
  'search-page.results.product-results.third-party.channel-type-label': 'チャンネル',
  'search-page.results.product-results.third-party.conversation-search-result.label': 'チャンネル',
  'search-page.results.product-results.third-party.conversation-search-result.member-count':
    '{count, plural, other {{count,number} 人のメンバー}}',
  'search-page.results.product-results.third-party.conversation-search-result.time-since-label':
    '最後にアクティブだった日: {formattedDate}',
  'search-page.results.product-results.third-party.conversation-search-result.unknown-channel': '不明なチャンネル',
  'search-page.results.product-results.third-party.external-people-label': '外部ユーザー',
  'search-page.results.product-results.third-party.external-person-label': '外部ユーザー',
  'search-page.results.product-results.third-party.last-active': '最後にアクティブだった日: {relativeDate}',
  'search-page.results.product-results.third-party.message-type-label': 'メッセージ',
  'search-page.results.product-results.third-party.no-contributors-label': '#{channelName} の外部ユーザー',
  'search-page.results.product-results.third-party.private-conversation-text': '{users} が非公開で会話中',
  'search-page.results.product-results.third-party.thread-type-label': 'スレッド',
  'search-page.results.product-results.third-party.title-and-channel-name': '#{channelName} の {title}',
  'search-page.results.product-results.third-party.title-with-remaining-contributors':
    '{remainingContributorsCount, plural, other {{title}、他 {remainingContributorsCount} 人のユーザー}}',
  'search-page.results.restricted-result-label': '制限付き',
  'search-page.results.restricted-result-tooltip': '特定のユーザーのみに公開されます',
  'search-page.show-more-breadcrumbs-button-label': 'ブレッドクラムをさらに表示',
  'search-page.verified-icon-label': '検証済み',
  'search-page.verified-icon-tooltip-message': 'このページは所有者または管理者によって検証済みです。',
  'search-result.result.count': '{count, plural, other {{count} 件の結果を表示中}}',
  'search-result.user-mention.external-person': '外部ユーザー',
};
